import React from 'react';
import InternalNav from '@/views/Layout/internal/InternalNavBar';

const Header = () => (
  <header style={{borderBottom: '0px'}}>
    <InternalNav />
  </header>
);

export default Header;
